import React from "react";
import { Button, Message } from "semantic-ui-react";

export function DangerZone({ organization, onDelete, deletion, deleting, error }) {
  const status = deletion?.status;
  const pending = status === "queued" || status === "running";
  const completed = status === "completed";
  return (
    <>
      <h2>Danger Zone</h2>
      <p>
        Deletion disables organization access and cleans up users, profiles, events, CRM data and related services. Data
        and files are retained as deleted records. Cleanup runs in the background.
      </p>
      {pending && (
        <Message info content="Deletion requested. Cleanup is still running; this page will update when it finishes." />
      )}
      {completed && <Message positive content="Organization cleanup completed." />}
      {["failed", "stalled", "unverified"].includes(status) && (
        <Message warning content={deletion.error || "Cleanup has not been verified. Retry deletion to finish it."} />
      )}
      {error && <Message error content={error.message} />}
      {!completed && (
        <Button
          content={`${["failed", "stalled", "unverified"].includes(status) ? "Retry deletion of" : "Delete"} ${
            organization?.name
          }`}
          icon="trash"
          color="red"
          onClick={onDelete}
          disabled={pending || deleting}
          loading={deleting}
        />
      )}
    </>
  );
}
